// packages
import 'intersection-observer';
import yall from 'yall-js';

// local imports
import { AdLoader } from './ads/loader';
import { createMap } from './components/map';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', yall);

createMap('mapbox://styles/latimes/ckf74miqv1l1119lnssolcnu1');
